// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MemberList__container-ee73d1 {
  display: flex;
  flex-direction: column;
  padding: 0 8px 110px;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/MemberList/MemberList.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  padding: 0 8px 110px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MemberList__container-ee73d1`
};
module.exports = ___CSS_LOADER_EXPORT___;
